<div class="participant-card">
  <div class="participant-card__header">
    @if (isLoading()) {
    <app-skeleton-text width="short"></app-skeleton-text>
    } @else {
    <span
      class="participant-card__status-badge"
      [class]="'participant-card__status-badge--' + statusBadgeClass()"
    >
      {{ statusBadgeText() }}
    </span>
    }
  </div>

  <div class="participant-card__body">
    <h3 class="participant-card__body__name">{{ displayName() }}</h3>
    @if (isLoading()) {
    <app-skeleton-text width="default"></app-skeleton-text>
    } @else {
    <p class="participant-card__body__instruction-text">{{ instructionText() }}</p>
    }
  </div>

  <div class="participant-card__footer">
    @if (isLoading()) {
    <app-skeleton-text width="med"></app-skeleton-text>
    } @else if (showContinueButton()) {
    <app-button (buttonClick)="onJoinSession()" size="small" type="primary"> Continue </app-button>
    }
  </div>
</div>
